// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1ClusterConditionStatus = {
  ClusterConditionStatusTrue: 'True',
  ClusterConditionStatusFalse: 'False',
  ClusterConditionStatusUnknown: 'Unknown',
} as const;
export type V1ClusterConditionStatus =
  (typeof V1ClusterConditionStatus)[keyof typeof V1ClusterConditionStatus];

export function instanceOfV1ClusterConditionStatus(value: any): boolean {
  for (const key in V1ClusterConditionStatus) {
    if (Object.prototype.hasOwnProperty.call(V1ClusterConditionStatus, key)) {
      if (
        V1ClusterConditionStatus[
          key as keyof typeof V1ClusterConditionStatus
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1ClusterConditionStatusFromJSON(
  json: any,
): V1ClusterConditionStatus {
  return V1ClusterConditionStatusFromJSONTyped(json, false);
}

export function V1ClusterConditionStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ClusterConditionStatus {
  return json as V1ClusterConditionStatus;
}

export function V1ClusterConditionStatusToJSON(
  value?: V1ClusterConditionStatus | null,
): any {
  return value as any;
}

export function V1ClusterConditionStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1ClusterConditionStatus {
  return value as V1ClusterConditionStatus;
}
